module.exports = __webpack_public_path__ + "static/media/djurgardsfestival_stadion_small.455d4ef1.jpeg";